<template>
  <Dialog v-model:visible="ShowStatusChangePopup" modal :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }" :closable="false">
    <template #header>

      <b-container>
        <b-row>
          <b-col>
            <h6 class="compo-heading">
              {{ t("assetManagement.agreementMaster.changeagreementstatus") }}
            </h6>
          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <i class="pi pi-times" @click="$emit('close')" />
          </b-col>
        </b-row>
      </b-container>

    </template>
    <b-container>
      <b-form @submit.prevent="ChangeStatus">
        <b-row>
          <b-col lg="6" md="6" sm="12" cols="12" class="d-flex align-items-center gap-2 mb-4">
            <p class="light-txt">
              {{ t("assetManagement.agreementMaster.oldstatus") }} :
            </p>
            <p class="activeclass">{{ AgreementStatus }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" md="6" sm="12" cols="12">
            <div class="field">
              <CustomDropdown :items="options.statusArray" :name="t('assetManagement.agreementMaster.newstatus')"
                :id="t('assetManagement.agreementMaster.newstatus')"
                :label="t('assetManagement.agreementMaster.newstatus')" :rules="{ required: false }"
                v-model="isForm.AgreementStatus" :requiredIcon="false" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12" cols="12" class="pe-0">
            <div class="field">
              <CustomTextArea :name="t('assetManagement.agreementMaster.reasonforchange')"
                :label="t('assetManagement.agreementMaster.reasonforchange')" :rules="{ required: false }"
                :id="t('assetManagement.agreementMaster.reasonforchange')" v-model="isForm.Reason"
                :rows="textarearow" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-5">
            <Footer @cancel="ChangeStatus()" :cancelhide="false" label="Update Status" />
          </b-col>
        </b-row>
      </b-form>
    </b-container>
  </Dialog>

  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";

import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import CustomTextArea from "../../../../../../../components/FormComponents/TextArea.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import { useI18n } from "vue-i18n";
import AgreementMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AgreementMasterService";
import { useForm } from "vee-validate";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";

export default defineComponent({
  components: {
    CustomDropdown,
    CustomTextArea,
    Footer,
    UpdatedSuccessfully,
  },
  props: {
    ShowStatusChangePopup: {
      type: Boolean,
      default: false,
    },
    AgreementId: {
      type: Number,
    },
    AgreementStatus: {
      type: String,
    },
  },

  setup(props, { emit }) {
    //Variable Deceration
    const { t } = useI18n();
    const textarearow = ref(3);
    let loading = ref(false);
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const updatepop = ref(false);
    let AgreementStatus = ref("");
    //

    const isForm: any = ref({
      Id: 0,
      AgreementStatus: ref(),
      Reason: "",
    });
    const copyisForm = JSON.parse(JSON.stringify(isForm.value));

    onMounted(() => {
      debugger;
      isForm.value.Id = props.AgreementId;
      AgreementStatus = AgreementStatus;
    });

    watch(
      () => props.AgreementId,
      (newVal) => {
        isForm.value.Id = props.AgreementId;
        AgreementStatus = AgreementStatus;
      }
    );

    // Function

    let options = ref({
      statusArray: [
        { name: "Active", value: "1" },
        { name: "Pending", value: "2" },
        { name: "Expired", value: "3" },
        { name: "Cancelled", value: "4" },
      ],
    });

    const ChangeStatus = handleSubmit(async (values) => {
      debugger;
      loading.value = true;
      try {
        debugger;
        const response = await AgreementMasterService.updateStatus(
          isForm.value
        );
        let data = response["result"][0];
        console.log(data);

        loading.value = false;
        let msg = response["ErrorInfo"].ErrorCode;
        if (response["result"] == false && msg == null) {
          updatepop.value = true;
        }
      } catch (error) {
        loading.value = false;

        alert(error);
      }
    });

    function closetrigger() {
      debugger;
      isForm.value.AgreementStatus = ref();
      updatepop.value = false;
      emit("close");
    }

    return {
      t,
      textarearow,
      options,
      isForm,
      ChangeStatus,
      updatepop,
      closetrigger,
    };
  },
});
</script>

<style lang="scss" scoped>
.activeclass {
  color: #444444;
  font-weight: 500;
}
</style>
